module.exports = __webpack_public_path__ + "static/media/GNB_03_search.f953df27.svg";